import Psychological, { PsychologicalSections } from './Psychological';

export default Psychological;
export { PsychologicalSections };
